import { inject, Injectable } from '@angular/core';

import { map, Observable, of, switchMap, tap } from 'rxjs';

import {
  JobTemplatesJobBoardStoreService,
  OfferJobBoardStoreService,
} from '@recruitee/job-boards-data';
import { JobBoard } from '@recruitee/job-boards-types';
import { JobKind } from '@recruitee/workflow-automations-types';

@Injectable()
export class SubmitToJobBoardsActionDataFacade {
  private readonly offerJobBoardStoreService = inject(OfferJobBoardStoreService);
  private readonly jobTemplatesJobBoardStoreService = inject(JobTemplatesJobBoardStoreService);

  public getJobBoards(jobId: number, jobKind: JobKind): Observable<JobBoard[]> {
    if (jobKind === JobKind.Job) {
      return this.offerJobBoardStoreService.getOfferJobBoardsLoaded(jobId).pipe(
        tap(loaded => {
          if (!loaded) {
            this.offerJobBoardStoreService.fetchOfferJobBoards(jobId);
          }
        }),
        switchMap(() =>
          this.offerJobBoardStoreService
            .getOfferJobBoards(jobId)
            .pipe(map(jobBoards => this.filterValidJobBoards(jobBoards))),
        ),
      );
    }
    if (jobKind === JobKind.JobTemplate) {
      return this.jobTemplatesJobBoardStoreService.getJobTemplatesJobBoardsLoaded(jobId).pipe(
        tap(loaded => {
          if (!loaded) {
            this.jobTemplatesJobBoardStoreService.fetchJobTemplatesJobBoards(jobId);
          }
        }),
        switchMap(() =>
          this.jobTemplatesJobBoardStoreService
            .getJobTemplatesJobBoards(jobId)
            .pipe(map(jobBoards => this.filterValidJobBoards(jobBoards))),
        ),
      );
    }
    return of([]);
  }

  private filterValidJobBoards(jobBoards: JobBoard[]): JobBoard[] {
    return jobBoards.filter(
      jobBoard =>
        !jobBoard.autoPosting &&
        !jobBoard.credentialsStructure?.length &&
        (!jobBoard.validation || jobBoard.validation.valid),
    );
  }
}
